import React from "react";
import { languages } from "../../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import PictureIcon from "@material-ui/icons/Photo";
import Tooltip from "@material-ui/core/Tooltip";
import DiaPhotoDialog from "../../../components/settings/slideshow/DiaPhotoDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import UpgradeDialog from "../../../components/UpgradeDialog";
import {
  getFileTooLargeMessage,
  getUploadErrorMessage,
} from "../../../util/uploadErrors";

class DiaPhotoContainer extends React.Component {
  state = {
    dialogOpen: false,
    title: this.props.structureElement
      ? this.props.structureElement.photoTitle || ""
      : "",
    photoURL: this.props.structureElement
      ? this.props.structureElement.photoURL || ""
      : "",
    errorMessagePhoto: "",
    upgradeDialogOpen: false,
  };

  toggleUpgradeDialog = () => {
    if (!this.state.upgradeDialogOpen) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("paywall_slideshow_photo");
      }
      // mailer lite paywall seen
      window.firebase
        .firestore()
        .collection("paywallSeenRequests")
        .doc()
        .set({ uid: this.props.user.uid });
    }
    this.setState({ upgradeDialogOpen: !this.state.upgradeDialogOpen });
  };

  toggleDialog = () => {
    this.setState({ dialogOpen: !this.state.dialogOpen });
  };

  handleTitleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessagePhoto: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessagePhoto: getUploadErrorMessage(error, 1) };

    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });

    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getMetadata()
      .then((metadata) => {
        const uploadedFileSize = parseInt((metadata || {}).size || "0", 10);
        if (uploadedFileSize > 1 * 1024 * 1024) {
          this.setState({
            errorMessagePhoto: getFileTooLargeMessage(1),
            photoURL: "",
          });
          storageRef.child(filename).delete().catch(() => {});
          return;
        }
        return storageRef.child(filename).getDownloadURL();
      })
      .then((url) => {
        if (!url) {
          return;
        }
        let photoNum = null;
        if (this.props.structureElement) {
          photoNum = this.props.structureElement.photoNum;
        }

        if (photoNum === null) {
          ["", "1", "2", "3", "4", "5", "6", "7", "8"]
            .reverse()
            .forEach((x) => {
              if (
                this.props.dia["diaPhotoIndex" + x] === null ||
                this.props.dia["diaPhotoIndex" + x] === undefined
              ) {
                photoNum = x;
              }
            });
        }

        if (photoNum !== null) {
          let toUpdate = {};
          toUpdate["diaPhotoURL" + photoNum] = url;
          window.firebase
            .firestore()
            .collection("tournaments")
            .doc(this.props.tournament[".key"])
            .collection("dias")
            .doc(this.props.dia.id)
            .update(toUpdate)
            .then(() => {
              this.setState({ photoURL: url });
            });
        }
      });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "diaPictures/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"]
      );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    let numInDia = null;
    let photoNum = null;
    if (this.props.structureElement) {
      numInDia = this.props.structureElement.numInDia;
      photoNum = this.props.structureElement.photoNum;
    }

    if (numInDia === null) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    if (photoNum === null) {
      ["", "1", "2", "3", "4", "5", "6", "7", "8"].reverse().forEach((x) => {
        if (
          this.props.dia["diaPhotoIndex" + x] === null ||
          this.props.dia["diaPhotoIndex" + x] === undefined
        ) {
          photoNum = x;
        }
      });
    }

    if (photoNum !== null) {
      let toUpdate = {};
      toUpdate["diaPhotoTitle" + photoNum] = this.state.title;
      toUpdate["diaPhotoIndex" + photoNum] = numInDia;

      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("dias")
        .doc(this.props.dia.id)
        .update(toUpdate)
        .then(() => {
          if (!this.props.structureElement) {
            this.setState({ title: "", photoURL: "" });
          }
        });
    }
  };

  render() {
    let allowedToUpload = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToUpload = true;
    }

    return (
      <div style={{ display: "inline-block" }}>
        <DiaPhotoDialog
          open={this.state.dialogOpen}
          title={this.state.title}
          toggleDialog={this.toggleDialog}
          handleTitleChange={this.handleTitleChange}
          handleSubmit={this.handleSubmit}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          dia={this.props.dia}
          storageRef={this.getStorageRef()}
          errorMessagePhoto={this.state.errorMessagePhoto}
          allowedToUpload={true}
          photoURL={this.state.photoURL}
          isUploading={this.state.isUploading}
        />
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeTextDesign}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />

        <div>
          <div>
            {this.props.edit ? (
              <IconButton
                aria-label="Change"
                onClick={
                  allowedToUpload ? this.toggleDialog : this.toggleUpgradeDialog
                }
                style={{
                  height: 30,
                  width: 30,
                  marginLeft: 5,
                  marginRight: 5,
                }}
                disabled={this.props.dia.isPSD}
              >
                <CreateIcon
                  style={{
                    height: 20,
                    width: 20,
                    position: "absolute",
                    top: 6,
                  }}
                />
              </IconButton>
            ) : (
              <Tooltip title={languages.present.picture}>
                <IconButton
                  onClick={
                    allowedToUpload
                      ? this.toggleDialog
                      : this.toggleUpgradeDialog
                  }
                  size="small"
                >
                  <PictureIcon style={{ height: 20, width: 20 }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(DiaPhotoContainer);
